import React, { useEffect, useState } from 'react'
import { withAuth } from '../AuthContext'
import { withSearch } from '../SearchContext'
import { withRouter } from 'react-router-dom'
import Notification from '../Utils/Notification'
import { SUCCESS } from '../../utils/constants'
import { shouldTranslateTo } from '../../utils/utils'
import styled from 'styled-components'
import Error from '../Utils/Error'

import {
  Title,
  Subtitle,
  CustomSubtitle,
  Input,
  ActionButtons,
  LoadingButton,
  CustomSelect,
  HelpText,
} from '../Utils/CustomClasses'

const ContainerBox = styled.div`
  padding: 30px 36px 55px 36px;
  background-color: #ffffff;

  @media (max-width: 767px) {
    padding: 25px 25px 25px 25px;
  }
`

const CurrentPhone = styled.div`
  padding: 10px 0 40px;
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
`

const BreakSub = styled(Subtitle)`
  overflow-wrap: anywhere;
`

const FlexBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  column-gap: 30px;

  @media only screen and (max-width: 767px) {
    gap: 10px;
    flex-direction: column;
    margin-bottom: 30px;
  }
`

const InputDiv = styled.div`
  width: 100%;
  min-width: 270px;
  flex: 1;
`

const HelpDiv = styled.div`
  width: 100%;
  min-width: 270px;
  flex: 1;
`

const FormContent = styled.div`
  width: 40vw;
  min-width: 250px;
  padding-right: 5px;

  @media screen and (max-width: 768px) {
    width: 100%;
  }

  button {
    width: -webkit-fill-available;
  }
`

const ErrorWrapper = styled.div`
  margin: 20px 0 0 0;
`

const EditPhoneNumberApp = ({ data, search, onUpdate }) => {
  const [phone, setPhone] = useState('')
  const [phoneCodeId, setPhoneCodeId] = useState('')
  const [loading, setLoading] = useState(false)
  const [pageText, setPageText] = useState([])
  const [error, setError] = useState(null)
  const [phoneCodeIdError, setPhoneCodeIdError] = useState(false)
  const [phoneError, setPhoneError] = useState(false)
  const [codes, setCodes] = useState({})

  useEffect(() => {
    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageText(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    getPageText('profile-phone', language)

    setPhoneCodeId(data.auth.user.phoneCodeId)
    setPhone(data.auth.user.phone)

    const countries = search.countries.sort((a, b) => a.nicename - b.nicename)

    const codes = countries.map((item) => {
      return {
        label: item.nicename + ' -- [+' + item.phonecode + ']',
        value: item.phonecode,
      }
    })

    setCodes(codes)
  }, [])

  const handleChange = ({ value }) => {
    setError(false)
    setPhoneCodeIdError(false)
    setPhoneCodeId(value)
  }

  const handleInputChange = (event) => {
    setError(false)
    const target = event.target
    setPhone(target.value)
  }

  const handleSubmit = () => {
    if (!phoneCodeId) {
      setPhoneCodeIdError(true)
      setError(`${pageText[10]}`)
      return
    } else if (!phone) {
      setPhoneError(true)
      setError(`${pageText[11]}`)
      return
    }

    setLoading(true)

    const phoneDetails = {
      phone: phone,
      phoneCodeId: phoneCodeId,
    }

    data.auth.updateUser(phoneDetails).then(() => {
      axios
        .post('/api/send-sms-token', {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then(() => {
          Notification({
            type: SUCCESS,
            message: `${pageText[12]}`,
          })

          const phoneDetails = {
            phoneStatus: 'verified',
          }
          data.auth.updateUser(phoneDetails)

          window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })

          setTimeout(function () {
            onUpdate()
          }, 1000)
        })
        .catch((e) => {
          Notification({
            data: e,
          })
          setLoading(false)
        })
    })
  }

  if (pageText.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">{pageText[13]}</span>
        </div>
      </div>
    )
  }
  return (
    <ContainerBox>
      <Title
        size="29px"
        sizemd="29px"
        sizesm="24px"
        margin="0"
        dangerouslySetInnerHTML={{
          __html: `${pageText[1]}`,
        }}
      ></Title>

      {phone && phoneCodeId ? (
        <CurrentPhone>
          <Subtitle size="22px" weight="400">
            {pageText[2]}
          </Subtitle>
          <BreakSub size="22px" bold>
            {'+' + phoneCodeId + ' ' + phone}
          </BreakSub>
        </CurrentPhone>
      ) : (
        <CurrentPhone>
          <Subtitle></Subtitle>
        </CurrentPhone>
      )}

      <form
        method="POST"
        action="/"
        name="myForm"
        aria-label="Add phone number"
        onSubmit={(event) => {
          event.preventDefault()
          handleSubmit()
          return false
        }}
      >
        <input
          type="hidden"
          name="csrf-token"
          value={window.Laravel.csrfToken}
        />
        <FlexBox>
          <InputDiv>
            <CustomSubtitle
              bold
              size="18px"
              margin="0 0 11px 0px"
              dangerouslySetInnerHTML={{
                __html: `${pageText[3]}`,
              }}
            />
            <CustomSelect
              width="100%"
              id="phonecode"
              name="phonecode"
              className={`${phoneCodeIdError && 'red-border'}`}
              marginsm="0"
              defaultValue={{
                value: phoneCodeId,
                label: phoneCodeId !== undefined ? phoneCodeId : pageText[4],
              }}
              isDisabled={false}
              isLoading={false}
              isClearable={false}
              isRtl={false}
              isSearchable={true}
              options={codes}
              onChange={(e) => handleChange(e)}
            />
          </InputDiv>
          <HelpDiv>
            <HelpText
              size="14px"
              sizesm="14px"
              dangerouslySetInnerHTML={{
                __html: `${pageText[5]}`,
              }}
            />
          </HelpDiv>
        </FlexBox>
        <FlexBox>
          <InputDiv>
            <CustomSubtitle
              bold
              size="18px"
              margin="0 0 11px 0px"
              dangerouslySetInnerHTML={{
                __html: `${pageText[6]}`,
              }}
            />
            <Input
              id="phone"
              type="text"
              name="phone"
              marginsm="0"
              className={`${phoneError && 'red-border'}`}
              required
              value={phone}
              onChange={(e) => handleInputChange(e)}
            />
          </InputDiv>
          <HelpDiv>
            <HelpText
              size="14px"
              sizesm="14px"
              dangerouslySetInnerHTML={{
                __html: `${pageText[7]}`,
              }}
            />
          </HelpDiv>
        </FlexBox>

        <FormContent>
          {loading ? (
            <LoadingButton padding="10px 10px">{pageText[8]}</LoadingButton>
          ) : (
            <ActionButtons type="submit" padding="10px 10px">
              {pageText[8]}
            </ActionButtons>
          )}
        </FormContent>

        <ErrorWrapper>{error && <Error error={error} />} </ErrorWrapper>
      </form>
    </ContainerBox>
  )
}

export default withRouter(withSearch(withAuth(EditPhoneNumberApp)))
